export default store => ({
  inserted: (el, binding) => {
    const DISABLED = binding.arg === 'disabled'
    const status = binding.modifiers

    if (DISABLED) {
      // 禁用控制
      if (binding.value) {
        if (status.visible) return el.parentNode.removeChild(el)
        if (status.editable) el.style.pointerEvents = 'none'
      }
    } else {
      // 启用控制
      let bindPermission = binding.expression
      let targetIndex = store.state.main.user.permissionTags.findIndex(
        item => item === bindPermission
      )
      if (targetIndex === -1) {
        el.parentNode.removeChild(el)
      }
    }
  }
})
